import React from "react";
import { createRoot } from "react-dom/client";
import "./assets/styles/index.scss";
import { Provider } from "react-redux";
import { store } from "./app/store";
import App from "./App";
import styles from "./assets/styles/index.scss?inline";

const container = document.getElementById("calculator-public-mfe");

if (container) {
  const shadowRoot = container.attachShadow({ mode: "open" });

  const style = document.createElement("style");
  style.textContent = styles;
  shadowRoot.appendChild(style);

  const root = createRoot(shadowRoot);

  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>
  );
}
